export default (props) => (
  /**
   * Botão "checked" com cor parametrizada.
   * Utilizado como confirmação em "Importar Projeto(.gba)"
   * que o arquivo esta pronto para ser importado.
   */
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.04201 8.88102C4.82613 8.88102 4.61839 8.79546 4.46503 8.64211L1.20185 5.37893C0.883238 5.06013 0.883238 4.54377 1.20185 4.22516C1.52065 3.90655 2.037 3.90655 2.35562 4.22516L4.99422 6.86377L10.5262 0.374997C10.8186 0.0325882 11.3332 -0.00877301 11.6764 0.283398C12.0192 0.575759 12.0602 1.09079 11.768 1.43358L5.6628 8.59432C5.51511 8.76751 5.30188 8.8712 5.0743 8.88026C5.06354 8.88064 5.05277 8.88102 5.04201 8.88102Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
